import { pushData } from './auth';

export const testRecommendation = async (address, data) => {
  await pushData(`testRecommendations/${address}`, data);
};
